// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__K1MP_","rightAdornment":"Header_rightAdornment__IB9UG"};